import { Field, Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { useDispatch } from 'react-redux'
import { ElectionModel } from './models/ElectionModel'
import * as Yup from 'yup'
import * as actions from './redux/electionsActions'

export interface ElectionFormProps {
  obj: ElectionModel
  handleClose: () => void
}

export function ElectionEditForm(props: ElectionFormProps) {
  const [isMulti, setIsMulti] = useState(false)
  const [standardChoice, setStandardChoice] = useState(false)
  const ElectionEditSchema = Yup.object().shape({
    name: Yup.string().required('Assunto é obrigatório.'),
    standard_options: Yup.boolean(),
    is_multiple: Yup.boolean(),
    secret_vote: Yup.string().required('Voto secreto é obrigatório.'),
  })
  const dispatch: any = useDispatch()

  const saveElection = (obj: any) => {
    obj.is_multiple = isMulti
    obj.standard_options = standardChoice
    if (!obj.uuid) {
      obj.status = 'Ativa'
      dispatch(actions.createElection(obj)).then(() => {
        props.handleClose()
      })
    } else {
      dispatch(actions.updateElection(obj)).then(() => {
        props.handleClose()
      })
    }
  }

  useEffect(() => {
    setIsMulti(props.obj?.is_multiple)
  }, [props.obj])

  return (
    <>
      {props.obj ? (
        <Formik
          enableReinitialize={true}
          initialValues={props.obj}
          validationSchema={ElectionEditSchema}
          onSubmit={(values) => {
            saveElection(values)
          }}
        >
          {({ handleSubmit, setFieldValue, getFieldProps, values, errors, touched }) => (
            <>
              <Form className='form form-label-right'>
                <Modal.Body>
                  <div className='mb-10' style={{ textAlign: 'left' }}>
                    <label className='form-label'>Assunto</label>
                    <Field
                      type='text'
                      name='name'
                      className='form-control form-control-solid'
                      placeholder='Assunto'
                    />
                    {errors.name && touched.name ? (
                      <span style={{ color: 'red' }}>{errors.name}</span>
                    ) : null}
                  </div>
                  <div className='mb-10' style={{ textAlign: 'left' }}>
                    <label className='form-label'>Voto Secreto</label>
                    <Field
                      as='select'
                      name='secret_vote'
                      className='form-select form-select-solid'
                      aria-label='Select example'
                      placeholder='Voto Secreto'
                    >
                      <option>Selecione...</option>
                      <option value='Sim'>Sim</option>
                      <option value='Não'>Não</option>
                    </Field>
                    {errors.secret_vote && touched.secret_vote ? (
                      <span style={{ color: 'red' }}>{errors.secret_vote}</span>
                    ) : null}
                  </div>
                  {!props.obj.uuid ? (
                    <div className='mb-10' style={{ textAlign: 'left' }}>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        value=''
                        onChange={() => {
                          setStandardChoice(!standardChoice)
                        }}
                        id='standardChoice'
                      />
                      <label
                        className='form-check-label px-3 text-solid'
                        htmlFor='standardChoice'
                      >
                        Criar opções de voto padrão (Sim, Não, Abstenção)?
                      </label>
                    </div>
                  ) : null}
                  <div className='mb-10' style={{ textAlign: 'left' }}>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value=''
                      checked={isMulti}
                      onChange={() => {
                        setFieldValue('is_multiple', !isMulti)
                        setIsMulti(!isMulti)
                      }}
                      id='isMulti'
                    />
                    <label className='form-check-label px-3' htmlFor='isMulti'>
                      A eleição possui múltipla escolha?
                    </label>
                  </div>
                  {isMulti ? (
                    <>
                      <div className='mb-10' style={{ textAlign: 'left' }}>
                        <label className='form-label'>Número mínimo de escolha</label>
                        <Field
                          type='number'
                          name='min_vote'
                          className='form-control form-control-solid'
                          placeholder='Número mínimo de escolhas'
                          min='1'
                          max='250'
                        />
                        {errors.min_vote || touched.min_vote ? (
                          <span style={{ color: 'red' }}>{errors.min_vote}</span>
                        ) : null}
                      </div>
                      <div className='mb-10' style={{ textAlign: 'left' }}>
                        <label className='form-label'>Número máximo de escolhas</label>
                        <Field
                          type='number'
                          name='max_vote'
                          className='form-control form-control-solid'
                          placeholder='Número máximo de escolhas'
                          min={getFieldProps('min_vote')}
                          max='250'
                        />
                        {errors.max_vote || touched.max_vote ? (
                          <span style={{ color: 'red' }}>{errors.max_vote}</span>
                        ) : null}
                      </div>
                    </>
                  ) : null}
                </Modal.Body>
              </Form>
              <Modal.Footer>
                <button
                  id='modal-close-button'
                  type='button'
                  className='btn btn-light'
                  onClick={props.handleClose}
                >
                  Fechar
                </button>
                <button type='button' className='btn btn-primary' onClick={() => handleSubmit()}>
                  Salvar
                </button>
              </Modal.Footer>
            </>
          )}
        </Formik>
      ) : null}
    </>
  )
}
